export default __webpack_public_path__ + "static/media/praticha.44136522.svg";